module.exports = __webpack_public_path__ + "images/entity-filter-0d609660.svg";